import {  setGetWithdrawalsByIdAction } from '../action';
import { getWithdrawalsById } from '../api/getWithdrawalsById';

export const setGetWithdrawalsById = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getWithdrawalsById(params);

            dispatch(setGetWithdrawalsByIdAction(data.data))

            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}